import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ShowBottomBar, ShowTopBar } from "../../../../services/ToggleNativeBar";
import UserService from "../../../../services/UserService";
import Button from "../../../Reusable/Button";
import TenantManager from "../Managers/TenantManager";
import { Tenant } from "../Types";
import { getTenantText } from "../../../../utils/translationHelpers";
import { IButtonAction, handleRedirect } from "../../../../utils/CommonFunctions";
import ChangeLocation from "./ChangeLocation";

const SelectTenant = () => {
  const [t] = useTranslation("translations");
  const history = useNavigate();

  useEffect(() => {
    ShowTopBar(true);
    ShowBottomBar(false);
  }, []);

  const [items, setItems] = useState<Array<Tenant>>(UserService.getAttribute("tenants"));
  const [isDisabled] = useState<boolean>(false);

  const handleSaveButtonClick = () => {
    const button_action: IButtonAction = {
      type: "IN_APP",
      url: `${window.location.origin}/LOCATION_SELECTION/${ChangeLocation.displayName}`,
    }
    
    UserService.setAttribute("tenants", items);

    const pageName = "";
    const title = "";
    handleRedirect(button_action, history, title, pageName);
  };

  return (
    <div className="ls__container">
    <div className="ls__page ls__page--select_oht">
      <Helmet>
        <title>{t("LocationSelection.SelectTenant.page_title", {tenant: getTenantText("tenant")})}</title>
      </Helmet>
      <div className="ls__page__inner">
        <TenantManager items={items} setItems={setItems} />
      </div>
    </div>
      <div className="ls__bottom_button">
        <Button 
          buttonType="IN_APP"
          buttonClassname="ls__button"
          buttonText={t("LocationSelection.Save")}
          handleRedirect={(()=> handleSaveButtonClick())}
          showButtonIcon={false}
          buttonIconImage=""
          buttonIconClassname=""
          buttonIconPosition=""
        />
      </div>
      </div>
  );
};

SelectTenant.displayName = "SelectTenant";

export default SelectTenant;